<template>
	<div class="favouritesCartButton">
		<ButtonWithLoading
			@click.native="addToCart"
			text="Add to Cart"
			loadingText="Adding"
			successText="Added Item"
			failureText="Couldn't add item"
			:state="addState"
			class="btn-block"
			:class="(addState == null) ? 'product-add-to-cart-btn' : ''"
		>
			<IconBase>
				<IconCart/>
			</IconBase>
		</ButtonWithLoading>
	</div>
</template>

<script>
import ButtonWithLoading from "@/components/buttonWithLoading";
import IconBase from "@/components/iconbase";
import IconCart from "@/components/icons/IconCart.vue";
import { makeProductObject } from "@/gaUtils"

export default {
	name: 'FavouritesCartButton',
	components: {
		ButtonWithLoading,
		IconBase,
		IconCart
	},
	data(){
		return{
		addState: null,
		quantity: 1,
		deliveryOption: "Home Delivery"
		}
	},
	props:["product"],
	created(){
		//set quantity to pack size
		this.quantity = parseInt(this.product.pack_size) || 1;
	},
	methods:{
		addToCart() {
		this.addState = "loading";
		this.$store
			.dispatch("cart/addItem", {
				productId: this.product.id,
				quantity: this.quantity,
				deliveryOption: this.deliveryOption
			})
			.then(() => {
				//success adding item
				this.addState = "success";
				//send save data to google analytics
				try {
					const products = [makeProductObject(this.product, this.quantity, "favourites")]
					const ecommerce = {
						currencyCode: "NZD",
						add: {
							products
						}
					}
					console.log(ecommerce)
					this.$gtm.trackEvent({
						event: "addToCart",
						label: "favourites",
						ecommerce
					})
				} catch (error) {
					console.error("Analytics error ", error);
				}
				setTimeout(() => {
					this.addState = null;
					this.quantity = parseInt(this.product.pack_size) || 1;
				}, 1000);
			})
			.catch(error => {
				console.log(error);
				this.addState = "failure";
				setTimeout(() => {
					this.addState = null;
				}, 1000);
			});
		}
	}
}
</script>

<style lang="scss" scoped>

</style>
